import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";
import axiosInstance from "./axiosInterceptor";
import botApiUrl from "./botApiUrl";

const OAuthCallback = () => {
  const history = useHistory();
  const accessToken = window.localStorage.getItem("accessToken");
  const idUser = window.localStorage.getItem("idUser");

  useEffect(() => {
    const trocarCodigoPorToken = async () => {
      if(!accessToken){
        return;
      }
      
      const urlParams = new URLSearchParams(window.location.search);
      const code = urlParams.get("code");

      if (!code) {
        console.error("Código não encontrado na URL");
        return;
      }

      const options = {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
      };

      try {
        // 1. Trocar o código por token
            console.log('/auth/google');
       // console.log(accessToken);
        const res = await botApiUrl.post("/auth/google", { code }, options);
        const tokenData = res.data;
        console.log("Token recebido do Google:", tokenData);

        const expiresAt = Date.now() + tokenData.expires_in * 1000;

        // 2. Salvar no localStorage
        window.localStorage.setItem("tokenGoogle", tokenData.access_token);
        window.localStorage.setItem("tokenGoogleExpiresAt", expiresAt);
        window.localStorage.setItem("refresh_token", tokenData.refresh_token);

        // 3. Buscar ID da loja
        const lojaRes = await axiosInstance.get(
          `https://api-techfood.lifix.com.br/v1/restaurantes/usuario/${idUser}`,
          options
        );
        const idLoja = lojaRes.data.id;

        // 4. Atualizar tokens do restaurante
        await axios.put(
          `https://api-techfood.lifix.com.br/v1/restaurantes/${idLoja}/atualizarTokensGoogle`,
          {
            googleTokenProducao: tokenData.access_token,
            googleTokenRefresh: tokenData.refresh_token,
            googleTokenTimestamp: expiresAt,
          },
          options
        );

        // 5. Redirecionar
        history.push("/");
      } catch (err) {
        console.error(
          "Erro ao autenticar com o Google:",
          err.response?.data || err.message
        );
      }
    };

    trocarCodigoPorToken();
  }, [accessToken, idUser]);

  return <div>Autenticando com Google...</div>;
};

export default OAuthCallback;
